export { precharge_PT_BR } from "./precharge-pt-br";
export type { prechargeTranslations } from "./precharge-pt-br";
export { precharge_EN_US } from "./precharge-en-us";
export { precharge_ES_MX } from "./precharge-es-mx";
export { precharge_FR_FR } from "./precharge-fr-fr";
